<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <el-button
            type="primary"
            icon="el-icon"
            class="active-icon"
            @click="getUser"
            >{{ $t("m.index.setting.all") }}</el-button
          >
        </div>
        <div class="box-header-right">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="active-icon"
            @click="dialogTableVisible = true"
          ></el-button>
        </div>
      </div>
      <!--内容-->
      <div style="height: calc(100% - 55px)">
        <div class="box-content">
          <div
            @click="checkDevice(item)"
            :class="[
              item.id == activeUserId1
                ? 'box-item box-half box-active'
                : 'box-item box-half',
            ]"
            v-for="item in userList"
            v-bind:key="item.id"
            style="position: relative;"
          >
            <div class="box-item-img">
              <el-avatar :src="item"></el-avatar>
            </div>
            <div class="box-item-text">
              <div>{{ $t("m.index.setting.user") }}：{{ item.name }}</div>
              <div>{{ $t("m.index.setting.company") }}：{{ item.company }}</div>
              <div>{{ $t("m.index.setting.address") }}：{{ item.address }}</div>
            </div>
            <div style="position: absolute; right: 20px;z-index: 999;border-left: 1px solid;">
              <el-button @click="toDevice(item)" type="text" class="box-item-btn">查看设备</el-button>
            </div>
          </div>
    
        </div>
        <div class="table-footer">
          <el-pagination
              v-show="total > 0"
              background
              align="right"
              layout="prev, pager, next"
              @current-change="userPageChange"
              :page-size="pageSize"
              :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="main-box border-1px-all">
      <section>
        <div class="flex flex-between">
          <div class="title-bc">{{ $t("m.index.setting.userDetail") }}</div>
          <div class="line-right">
            <el-button type="primary" @click="saveUserInfo">{{
              $t("m.button.save")
            }}</el-button>
            <el-button
              type="primary"
              icon="el-icon-delete"
              class="active-icon"
              @click="deleteUser()"
              >{{ $t("m.commentDetail.delete") }}</el-button
            >
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">{{
              $t("m.userList.userTable.username")
            }}</span>
            <el-input placeholder="" type="text" v-model="currentUser1.name">
            </el-input>
          </div>
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">{{
              $t("m.userList.userTable.phone")
            }}</span>
            <el-input placeholder="" type="text" v-model="currentUser1.phone">
            </el-input>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">{{
              $t("m.userList.userTable.email")
            }}</span>
            <el-input placeholder="" type="text" v-model="currentUser1.email">
            </el-input>
          </div>
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">{{
              $t("m.deviceManage.bindDevice.date")
            }}</span>
            <el-input
              placeholder=""
              type="text"
              v-model="currentUser1.createtime"
            >
            </el-input>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 100%">
            <span class="cus-input-title">{{
              $t("m.index.setting.company")
            }}</span>
            <el-input placeholder="" type="text" v-model="currentUser1.company">
            </el-input>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 100%">
            <span class="cus-input-title">{{
              $t("m.index.setting.address")
            }}</span>
            <el-input placeholder="" type="text" v-model="currentUser1.address">
            </el-input>
          </div>
        </div>
      </section>

      <section>
        <div
          class="flex flex-between"
          style="margin-top: 30px; margin-bottom: 10px"
        >
          <div class="title-bc">{{ $t("m.commentDetail.remark") }}</div>
        </div>
        <el-input placeholder="" type="textarea" v-model="currentUser1.note">
        </el-input>
      </section>
    </div>
    <!--------搜索弹框---------->
    <el-dialog
      :title="$t('m.chart.table.search')"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <div>
        <el-select
          v-model="params.searchParamName"
          :placeholder="$t('m.table.select')"
        >
          <!--                        <el-option-->
          <!--                                v-for="item in searchOptions"-->
          <!--                                :key="item.value"-->
          <!--                                :label="item.label"-->
          <!--                                :value="item.value">-->
          <!--                        </el-option>-->
          <el-option
            :key="searchOptions[0].value"
            :label="$t('m.options.userSearchOptions.name')"
            :value="searchOptions[0].value"
          >
          </el-option>
          <el-option
            :key="searchOptions[1].value"
            :label="$t('m.options.userSearchOptions.phone')"
            :value="searchOptions[1].value"
          >
          </el-option>
          <el-option
            :key="searchOptions[2].value"
            :label="$t('m.options.userSearchOptions.email')"
            :value="searchOptions[2].value"
          >
          </el-option>
        </el-select>
        <div class="flex flex-center flex-between" style="margin-top:10px;">
          <el-input v-model="params.searchParamValue" placeholder="">
          </el-input>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div type="primary" @click="searchUserList" class="dialog-footer-btn">
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
const item = {
  date: "2016-05-02",
  name: "王小虎",
  address: "上海市普陀区金沙江路 1518 弄",
};
export default {
  name: "equipment-list",
  data() {
    return {
      tableData: Array(20).fill(item),
      loadUserType: 0,
      loadBeanType: 0,
      loadReportType: 0,
      loadCommentType: 0,
      sortBeanType: 1,
      sortRepotType: 1,
      sortCommentType: 1,
      params: {
        searchParamName: "name",
        searchParamValue: "",
        searchBeanParamName: "keyword",
        searchBeanParamValue: "",
        searchDeviceParamName: 1,
        searchDeviceParamValue: "",
        searchReportParamName: "name",
        searchReportParamValue: "",
        searchCommentParamName: "keyword",
        searchCommentParamValue: "",
        orderBeanParamName: "/manage/bean/listByStockUserMan.do",
        orderBeanParamValue: "",
        orderDeviceParamName: 1,
        orderDeviceParamValue: "",
        orderReportParamName: "/manage/report/orderByLevelUserMan.do",
        orderReportParamValue: "",
        orderCommentParamName: "/manage/comment/getbyScoreForAUser.do",
        orderCommentParamValue: "",
      },
      searchOptions: [
        { value: "name", label: this.$t("m.options.userSearchOptions.name") },
        { value: "phone", label: this.$t("m.options.userSearchOptions.phone") },
        { value: "email", label: this.$t("m.options.userSearchOptions.email") },
        {
          value: "keyword",
          label: this.$t("m.options.beanManaSearchOptions.keyword"),
        },
        {
          value: "kind",
          label: this.$t("m.options.beanManaSearchOptions.kind"),
        },
        {
          value: "method",
          label: this.$t("m.options.beanManaSearchOptions.method"),
        },

        { value: 1, label: this.$t("m.options.deviceManaSearchOptions.name") },
        {
          value: 2,
          label: this.$t("m.options.deviceManaSearchOptions.deviceType"),
        },
        {
          value: 3,
          label: this.$t("m.options.deviceManaSearchOptions.serino"),
        },
        {
          value: 4,
          label: this.$t("m.options.deviceManaSearchOptions.status"),
        },

        {
          value: "name",
          label: this.$t("m.options.reportManaSearchOptions.name"),
        },
        {
          value: "keyword",
          label: this.$t("m.options.commentManaSearchOptions.name"),
        },
      ],
      orderOptions: [
        {
          value: "/manage/bean/listByStockUserMan.do",
          label: this.$t("m.options.beanManaOrderOptions.stock"),
        },
        {
          value: 1,
          label: this.$t("m.options.deviceManaOrderOptions.bindTime"),
        },
        {
          value: 2,
          label: this.$t("m.options.deviceManaOrderOptions.runTime"),
        },
        { value: 3, label: this.$t("m.options.deviceManaOrderOptions.hbTime") },
        {
          value: "/manage/report/orderByLevelUserMan.do",
          label: this.$t("m.options.reportManaOrderOptions.level"),
        },
        {
          value: "/manage/report/orderByColor.do",
          label: this.$t("m.options.reportManaOrderOptions.color"),
        },
        {
          value: "/manage/comment/getbyScoreForAUser.do",
          label: this.$t("m.options.commentManaOrderOptions.score"),
        },
        {
          value: "/manage/comment/selectOrderbyLevel.do",
          label: this.$t("m.options.commentManaOrderOptions.level"),
        },
      ],
      showChart: true,
      commentDetailDialog: false,
      refreshCommentDetail: false,
      selectCommentId: 0,
      pageSize: 20,
      pageNum: 1,
      total: 0,
      activeTabName: "sd",
      userList: [],
      beanPage: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      beanList: [],
      devicePage: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      deviceList: [],
      reportPage: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      reportList: [],
      selectReportId: 0,
      commentPage: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      commentList: [],
      selectDevice: { device: { name: "" } },
      deviceTimeLogDialog: false,
      deviceMaintainDialog: false,
      deviceRuntimePage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      deviceHbPage: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      deviceTimeActiveTab: "rt",
      deviceTimeList: [],
      deviceHbTimeList: [],
      deviceMaintainPage: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      deviceMaintainList: [],
      reportDetailDialog: false,
      reportKey: 0,
      detailReport: {
        name: "",
        level: "",
        type: "",
        weight: 0,
        color: "",
        user: {},
        suitVo: {
          bean: {
            name: "",
          },
          lineVoList: [], //曲线数据
          height: 0,
          weight: 0,
        },
      }, //曲线详情
      activeUserId: 0,
      loading: undefined,
      beanReportDialog: false,
      selectBeanId: 0,
      beanReportList: [],
      beanReportPage: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      maintainDetailDialog: false,
      maintainDetail: {},
      selectSuitId: 0,
      reportListDialog: false,
      deviceReportList: [],
      reportCommentListDialog: false,
      reportCommentList: [],
      reportCommentPage: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
      },
      addCommentDialog: false,
      refreshAddComment: false,
      activeUserId1: 0,
      currentUser1: {},

      date: "",
      company: "",
      address: "",
      remarks: "",
      selectValue: "",
      dialogTableVisible: false,
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    hideAddComment() {
      this.addCommentDialog = false;
      this.refreshAddComment = false;
    },
    reportCommentListClick() {
      this.reportCommentListDialog = true;
      this.getCommentList();
    },
    getCommentList() {
      this.$http
        .get(
          "/manage/comment/list.do?suitId=" +
            this.selectSuitId +
            "&pageSize=" +
            this.reportCommentPage.pageSize +
            "&pageNum=" +
            this.reportCommentPage.pageNum
        )
        .then(
          function(resp) {
            if (resp.data.success) {
              this.reportCommentList = resp.data.data.list;
              this.reportCommentPage.total = resp.data.data.total;
            } else {
              this.$message.error(this.$t("m.alert.error"));
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    getDeviceReportList(device) {
      this.$http
        .get("/manage/report/getOnlyListByDevice.do", {
          params: {
            pageNum: 1,
            pageSize: 20,
            serino: device.device.serino,
          },
        })
        .then(
          function(resp) {
            this.deviceReportList = resp.data.data.list;
            // this.reportPage.total = resp.data.data.total
            console.info(resp);
            this.reportListDialog = true;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    maintainDetailClick(maintain) {
      this.maintainDetail = maintain;
      this.maintainDetailDialog = true;
    },
    downLoadReport(report) {
      console.info(report);
      this.$http
        .get("/manage/report/getAReportById.do", {
          params: {
            reportId: report.report.id,
          },
        })
        .then(
          function(resp) {
            let fileName = report.report.name + ".json";
            saveAs(
              new Blob([JSON.stringify(resp.data.data)], {
                type: "",
              }),
              fileName
            );
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    reportDetailLoadingFinish() {
      this.loading.close();
    },
    getUser() {
      this.$http
        .get("/manage/user/list.do", {
          params: {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          },
        })
        .then(
          function(resp) {
            this.userList = resp.data.data.list;
            this.total = resp.data.data.total;

            this.activeUserId1 = resp.data.data.list[0].id;
            this.currentUser1 = resp.data.data.list[0];
              console.info(resp.data.data);
            // 避免时间戳精度丢失，将时间戳转换为字符串或使用parseInt
            this.currentUser1.createtime = this.$moment(
              parseInt(this.currentUser1.createtime)
            ).format("YYYY-MM-DD");

          
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    searchUserList() {
      this.loadUserType = 1;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
         background: "rgba(0, 0, 0, 0.7)",
      });
      this.loading = loading;
      if (this.params.searchParamValue.trim().length > 0) {
        let url = "";
        let params = new URLSearchParams();

        if (this.params.searchParamName == "name") {
          url = "/manage/user/listByName.do?name=" + this.params.searchParamValue;
          // params.append("name", this.params.searchParamValue);
        }
        if (this.params.searchParamName == "phone") {
          url = "/manage/user/listByPhone.do?phone=" + this.params.searchParamValue;
          // params.append("phone", this.params.searchParamValue);
        }
        if (this.params.searchParamName == "email") {
          url = "/manage/user/listByEmail.do?email=" + this.params.searchParamValue;
          // params.append("email", this.params.searchParamValue);
        }
        this.$http
          .get(url,{
          params: {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          },
        })
          .then(
            function(resp) {
              this.userList = resp.data.data.list;
              this.total = resp.data.data.total;
              this.dialogTableVisible = false;
              this.activeUserId1 = resp.data.data.list[0].id;
              this.currentUser1 = resp.data.data.list[0];
              // 避免时间戳精度丢失，将时间戳转换为字符串或使用parseInt
              this.currentUser1.createtime = this.$moment(
                parseInt(this.currentUser1.createtime)
              ).format("YYYY-MM-DD");
             
              console.info(resp);
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          })
      } else {
        this.getUser();
      }
      loading.close();
    },
    saveUserInfo() {
      this.$confirm(this.$t("m.alert.changeTip"), this.$t("m.alert.reminder"), {
        confirmButtonText: this.$t("m.alert.confirm"),
        cancelButtonText: this.$t("m.alert.cancel"),
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
             background: "rgba(0, 0, 0, 0.7)",
          });
          this.loading = loading;
          let params = new URLSearchParams();
          params.append("id", this.currentUser1.id);
          params.append("name", this.currentUser1.name);
          params.append("phone", this.currentUser1.phone);
          params.append("email", this.currentUser1.email);
          params.append("photo", this.currentUser1.photo);
          params.append("company", this.currentUser1.company);
          params.append("address", this.currentUser1.address);
          params.append("note", this.currentUser1.note);
          this.$http
            .post("/manage/user/update_informationmana.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.updateSuccess"));
                  //localStorage.setItem('photo', this.user.photo)
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
          loading.close();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.canceled"),
          });
        });
    },
    deleteUser() {
      this.$confirm(
        this.$t("m.alert.deleteConfirm"),
        this.$t("m.alert.reminder"),
        {
          confirmButtonText: this.$t("m.alert.confirm"),
          cancelButtonText: this.$t("m.alert.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
             background: "rgba(0, 0, 0, 0.7)",
          });
          this.loading = loading;
          let params = new URLSearchParams();
          params.append("id", this.currentUser1.id);
          params.append("delstatus", 1);
          this.$http
            .post("/manage/user/update_informationmana.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.deleteSuccess"));
                  this.getUser();
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
          loading.close();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.canceled"),
          });
        });
    },
    // eslint-disable-next-line no-unused-vars
    loadUserBasicInfo(row, event, column) {
      //加载用户相关信息，生豆、设备、曲线、杯测数据列表

      this.activeUserId = row.id;
      this.getBeanByUser(row.id);
      this.getDeviceByUserId(row.id);
      this.getReportByUserId(row.id);
      this.getCommentListByUserId(row.id);
    },
    getBeanByUser(userId) {
      this.$http
        .get("/manage/bean/listByUser.do", {
          params: {
            pageNum: this.beanPage.pageNum,
            pageSize: this.beanPage.pageSize,
            userId: userId,
          },
        })
        .then(
          function(resp) {
            this.beanList = resp.data.data.list;
            this.beanPage.total = resp.data.data.total;
            console.info(resp);
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    searchBeanList() {
      this.loadBeanType = 1;
      if (this.params.searchBeanParamValue.trim().length > 0) {
        let url = "";
        let params = new URLSearchParams();

        if (this.params.searchBeanParamName == "keyword") {
          url = "/manage/bean/searchByNameUserMan.do";
          params.append("keyword", this.params.searchBeanParamValue);
          params.append("userId", this.activeUserId);
          params.append("pageNum", this.beanPage.pageNum);
          params.append("pageSize", this.beanPage.pageSize);
        }
        if (this.params.searchBeanParamName == "kind") {
          url = "/manage/bean/searchByKindUserMan.do";
          params.append("kind", this.params.searchBeanParamValue);
          params.append("userId", this.activeUserId);
          params.append("pageNum", this.beanPage.pageNum);
          params.append("pageSize", this.beanPage.pageSize);
        }
        if (this.params.searchBeanParamName == "method") {
          url = "/manage/bean/selectByMethodUserMan.do";
          params.append("method", this.params.searchBeanParamValue);
          params.append("userId", this.activeUserId);
          params.append("pageNum", this.beanPage.pageNum);
          params.append("pageSize", this.beanPage.pageSize);
        }
        this.$http
          .post(url, params)
          .then(
            function(resp) {
              this.beanList = resp.data.data.list;
              this.beanPage.total = resp.data.data.total;
              console.info(resp);
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
      } else {
        this.getBeanByUser(this.activeUserId);
      }
    },
    sortBean(sortType) {
      this.loadBeanType = 2;
      this.sortBeanType = sortType;
      this.$http
        .get(this.params.orderBeanParamName, {
          params: {
            pageSize: this.beanPage.pageSize,
            pageNum: this.beanPage.pageNum,
            sort: sortType,
            userId: this.activeUserId,
          },
        })
        .then(
          function(resp) {
            this.beanList = resp.data.data.list;
            this.beanPage.total = resp.data.data.total;
            console.info(resp);
          }.bind(this)
        );
    },
    beanReportClick(bean) {
      console.info(bean);
      this.selectBeanId = bean.id;
      this.beanReportDialog = true;
      this.getReportByBean(this.selectBeanId);
    },
    getDeviceByUserId(userId) {
      this.$http
        .get("/manage/device/findBindByUserId.do", {
          params: {
            userId: userId,
          },
        })
        .then(
          function(resp) {
            this.deviceList = resp.data.data;

            console.info(resp);
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },

    searchDeviceList() {
      if (this.params.searchDeviceParamValue.trim().length > 0) {
        let params = new URLSearchParams();
        let url = "/manage/device/searchByKeyWordUserMan.do";
        params.append("keyword", this.params.searchDeviceParamValue);
        params.append("userId", this.activeUserId);
        params.append("type", this.params.searchDeviceParamName);

        this.$http
          .post(url, params)
          .then(
            function(resp) {
              this.deviceList = resp.data.data;
              console.info(resp);
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
      } else {
        this.getDeviceByUserId(this.activeUserId);
      }
    },
    sortDevice(sortType) {
      this.$http
        .get("/manage/device/findBindsByUserOrderBy.do", {
          params: {
            sortType: sortType,
            userId: this.activeUserId,
            type: this.params.orderDeviceParamName,
          },
        })
        .then(
          function(resp) {
            this.deviceList = resp.data.data;
            console.info(resp);
          }.bind(this)
        );
    },
    getReportByUserId(userId) {
      this.$http
        .get("/manage/report/getOnlyList.do", {
          params: {
            pageNum: this.reportPage.pageNum,
            pageSize: this.reportPage.pageSize,
            userId: userId,
          },
        })
        .then(
          function(resp) {
            this.reportList = resp.data.data.list;
            this.reportPage.total = resp.data.data.total;
            console.info(resp);
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    searchReportList() {
      this.loadReportType = 1;
      if (this.params.searchReportParamValue.trim().length > 0) {
        let url = "";
        let params = new URLSearchParams();

        if (this.params.searchReportParamName == "name") {
          url = "/manage/report/getOnlyListByUserSeaName.do";
          params.append("name", this.params.searchReportParamValue);
          params.append("userId", this.activeUserId);
          params.append("pageNum", this.beanPage.pageNum);
          params.append("pageSize", this.beanPage.pageSize);
        }

        this.$http
          .post(url, params)
          .then(
            function(resp) {
              this.reportList = resp.data.data.list;
              this.reportPage.total = resp.data.data.total;
              console.info(resp);
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
      } else {
        this.getReportByUserId(this.activeUserId);
      }
    },
    sortReport(sortType) {
      this.loadReportType = 2;
      this.sortRepotType = sortType;
      this.$http
        .get(this.params.orderReportParamName, {
          params: {
            pageNum: this.reportPage.pageNum,
            pageSize: this.reportPage.pageSize,
            sortType: sortType,
            userId: this.activeUserId,
          },
        })
        .then(
          function(resp) {
            this.reportList = resp.data.data.list;
            this.reportPage.total = resp.data.data.total;
            console.info(resp);
          }.bind(this)
        );
    },
    getReportByBean(beanId) {
      this.$http
        .get("/manage/report/getOnlyListByBean.do", {
          params: {
            pageNum: this.reportPage.pageNum,
            pageSize: this.reportPage.pageSize,
            beanId: beanId,
          },
        })
        .then(
          function(resp) {
            this.beanReportList = resp.data.data.list;
            this.beanReportPage.total = resp.data.data.total;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    getCommentListByUserId(userId) {
      this.$http
        .get("/manage/comment/getOnlyList.do", {
          params: {
            pageNum: this.commentPage.pageNum,
            pageSize: this.commentPage.pageSize,
            userId: userId,
          },
        })
        .then(
          function(resp) {
            this.commentList = resp.data.data.list;
            this.commentPage.total = resp.data.data.total;
            console.info(resp);
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    searchCommentList() {
      this.loadCommentType = 1;
      if (this.params.searchCommentParamValue.trim().length > 0) {
        let url = "";
        let params = new URLSearchParams();

        if (this.params.searchCommentParamName == "keyword") {
          url = "/manage/comment/searchByNameForAUsesr.do";
          params.append("keyword", this.params.searchCommentParamValue);
          params.append("userId", this.activeUserId);
          params.append("pageNum", this.commentPage.pageNum);
          params.append("pageSize", this.commentPage.pageSize);
        }

        this.$http
          .post(url, params)
          .then(
            function(resp) {
              this.commentList = resp.data.data.list;
              this.commentPage.total = resp.data.data.total;
              console.info(resp);
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
      } else {
        this.getCommentListByUserId(this.activeUserId);
      }
    },
    sortComment(sortType) {
      this.loadCommentType = 2;
      this.sortCommentType = sortType;
      this.$http
        .get(this.params.orderCommentParamName, {
          params: {
            pageNum: this.commentPage.pageNum,
            pageSize: this.commentPage.pageSize,
            sort: sortType,
            userId: this.activeUserId,
          },
        })
        .then(
          function(resp) {
            this.commentList = resp.data.data.list;
            this.commentPage.total = resp.data.data.total;
            console.info(resp);
          }.bind(this)
        );
    },
    dateFormatInside(row, column) {
      console.info(column);
      //.replace(/年|月/g, "-").replace(/日/g, " ")
      // 避免时间戳精度丢失
      return this.$moment(parseInt(row.report.createtime)).format("YYYY-MM-DD");
    },
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      //.replace(/年|月/g, "-").replace(/日/g, " ")
      // 避免时间戳精度丢失
      return this.$moment(parseInt(date)).format("YYYY-MM-DD");
    },
    dateFormat1(row) {
      var date = row.report.createtime;
      if (date == undefined) {
        return "";
      }
      //.replace(/年|月/g, "-").replace(/日/g, " ")
      // 避免时间戳精度丢失
      return this.$moment(parseInt(date)).format("YYYY-MM-DD");
    },

    dateFormat2(row) {
      var date = row.device.createtime;
      if (date == undefined) {
        return "";
      }
      //.replace(/年|月/g, "-").replace(/日/g, " ")
      // 避免时间戳精度丢失
      return this.$moment(parseInt(date)).format("YYYY-MM-DD");
    },

    deviceLogClick(device) {
      console.info(device);
      this.selectDevice = device;
      this.getDeviceHbTime();
      this.getDeviceTime();
      this.deviceTimeLogDialog = true;
    },
    deviceTimePageChange(val) {
      this.deviceRuntimePage.pageNum = val;
      this.getDeviceTime();
    },
    deviceTimePageSizeChange(val) {
      this.deviceRuntimePage.pageSize = val;
      this.getDeviceTime();
    },
    deviceHbTimePageChange(val) {
      this.deviceHbPage.pageNum = val;
      this.getDeviceHbTime();
    },
    deviceHbTimePageSizeChange(val) {
      this.deviceHbPage.pageSize = val;
      this.getDeviceHbTime();
    },
    getDeviceTime() {
      this.$http
        .get("/manage/deviceLog/list.do", {
          params: {
            deviceId: this.selectDevice.device.id,
            type: 1,
            pageNum: this.deviceRuntimePage.pageNum,
            pageSize: this.deviceRuntimePage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceRuntimePage.total = resp.data.data.total;
            this.deviceTimeList = resp.data.data.list;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    getDeviceHbTime() {
      this.$http
        .get("/manage/deviceLog/list.do", {
          params: {
            deviceId: this.selectDevice.device.id,
            type: 2,
            pageNum: this.deviceHbPage.pageNum,
            pageSize: this.deviceHbPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceHbPage.total = resp.data.data.total;
            this.deviceHbTimeList = resp.data.data.list;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },

    deviceMaintainClick(device) {
      console.info(device);
      this.selectDevice = device;
      this.selectDevice = device;
      this.activeDeviceId = device.device.id;
      this.getDeviceMaintain(this.activeDeviceId);
      this.deviceMaintainDialog = true;
    },
    deviceMaintainPageChange(val) {
      this.deviceMaintainPage.pageNum = val;
      this.getDeviceMaintain(this.activeDeviceId);
    },
    deviceMaintainPageSizeChange(val) {
      this.deviceMaintainPage.pageSize = val;
      this.getDeviceMaintain(this.activeDeviceId);
    },
    getDeviceMaintain(deviceId) {
      this.$http
        .get("/manage/deviceMaintain/list.do", {
          params: {
            deviceId: deviceId,
            pageNum: this.deviceMaintainPage.pageNum,
            pageSize: this.deviceMaintainPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceMaintainPage.total = resp.data.data.total;
            this.deviceMaintainList = resp.data.data.list;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    reportDetailClick(report, show) {
      console.info(report);
      this.selectReportId = report.report.id;
      this.selectSuitId = report.report.suitid;
      this.showChart = show;
      this.$http
        .get("/manage/report/getAReportById.do", {
          params: {
            reportId: report.report.id,
          },
        })
        .then(
          function(resp) {
            this.detailReport = resp.data.data;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
         background: "rgba(0, 0, 0, 0.7)",
      });
      this.loading = loading;
      this.reportDetailDialog = true;
      this.reportKey = this.selectReportId;
      setTimeout(() => {
        loading.close();
      }, 1000);
    },
    commentDetailClick(comment) {
      console.info(comment);
      this.selectCommentId = comment.id;
      this.selectSuitId = comment.suitid;
      // 在组件移除后，重新渲染组件
      this.refreshCommentDetail = false;
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refreshCommentDetail = true;
      });
      this.commentDetailDialog = true;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$i18n.locale === "en-US" ? "Total " : "总和";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === "time") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += " 小时";
        } else {
          sums[index] = "---";
        }
      });

      return sums;
    },
    userPageChange(val) {
      this.pageNum = val;
      if (this.loadUserType == 0) {
        this.getUser();
      } else if (this.loadUserType == 1) {
        this.searchUserList();
      }
    },
    userPageSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      if (this.loadUserType == 0) {
        this.getUser();
      } else if (this.loadUserType == 1) {
        this.searchUserList();
      }
    },
    beanPageChange(val) {
      this.beanPage.pageNum = val;

      if (this.loadBeanType == 0) {
        this.getBeanByUser(this.activeUserId);
      } else if (this.loadBeanType == 1) {
        this.searchBeanList();
      } else if (this.loadBeanType == 2) {
        this.sortBean(this.sortBeanType);
      }
    },
    beanPageSizeChange(val) {
      this.beanPage.pageNum = 1;
      this.beanPage.pageSize = val;
      if (this.loadBeanType == 0) {
        this.getBeanByUser(this.activeUserId);
      } else if (this.loadBeanType == 1) {
        this.searchBeanList();
      } else if (this.loadBeanType == 2) {
        this.sortBean(this.sortBeanType);
      }
    },
    reportPageChange(val) {
      this.reportPage.pageNum = val;
      if (this.loadReportType == 0) {
        this.getReportByUserId(this.activeUserId);
      } else if (this.loadReportType == 1) {
        this.searchReportList();
      } else if (this.loadReportType == 2) {
        this.sortReport(this.sortRepotType);
      }
    },
    reportPageSizeChange(val) {
      this.reportPage.pageNum = 1;
      this.reportPage.pageSize = val;
      if (this.loadReportType == 0) {
        this.getReportByUserId(this.activeUserId);
      } else if (this.loadReportType == 1) {
        this.searchReportList();
      } else if (this.loadReportType == 2) {
        this.sortReport(this.sortRepotType);
      }
    },
    beanReportPageChange(val) {
      this.beanReportPage.pageNum = val;
      this.getReportByBean(this.selectBeanId);
    },
    beanReportPageSizeChange(val) {
      this.beanReportPage.pageNum = 1;
      this.beanReportPage.pageSize = val;
      this.getReportByBean(this.selectBeanId);
    },
    commentPageChange(val) {
      this.commentPage.pageNum = val;

      if (this.loadCommentType == 0) {
        this.getCommentListByUserId(this.activeUserId);
      } else if (this.loadCommentType == 1) {
        this.searchCommentList();
      } else if (this.loadCommentType == 2) {
        this.sortComment(this.sortCommentType);
      }
    },
    commentPageSizeChange(val) {
      this.commentPage.pageNum = 1;
      this.commentPage.pageSize = val;
      if (this.loadCommentType == 0) {
        this.getCommentListByUserId(this.activeUserId);
      } else if (this.loadCommentType == 1) {
        this.searchCommentList();
      } else if (this.loadCommentType == 2) {
        this.sortComment(this.sortCommentType);
      }
    },
    checkDevice(item) {
      this.activeUserId1 = item.id;
      this.currentUser1 = item;
      // 避免时间戳精度丢失，使用parseInt确保正确解析时间戳
      this.currentUser1.createtime = this.$moment(
        parseInt(this.currentUser1.createtime)
      ).format("YYYY-MM-DD");
    },
    toDevice(item) {
      this.$router.push({
        path: "/on-allUserDeviceList",
        query: {
          id: item.id,
        },
      });
    }
  },
};
</script>

<style scoped>
.el-textarea__inner {
  height: 250px;
}
.box-item .box-item-img img {
  width: 54px;
}

.table-footer {
   position: sticky;
   bottom: 0;
   padding-top: 10px;
}
.box-content {
  gap: 15px;
}
.box-item{
  width: calc(50% - 10px) !important;
}
.box-active .box-item-btn {
  color: #b5b5b5 !important;
}
.box-item-btn {
  color: #7b7d8d;
  letter-spacing: 3px;
  writing-mode: tb;
}
</style>
